import React from 'react';
import Button from '../ui/Button';
import Icon from '../AppIcon';
import { Switch } from '../ui/Switch';
import { minCalendarDateInputParis } from '../../utils/hubupNotificationCalendarEvent';

const inputClass =
  'w-full rounded-md border border-input bg-background px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-ring';

export default function NotificationCalendarEventEditor({
  value,
  onChange,
  onBack,
  onRemove,
  disabled,
  showRemove,
}) {
  const draft = value;

  const patch = (partial) => onChange({ ...draft, ...partial });

  return (
    <div className="space-y-4">
      <div className="flex items-center justify-between gap-2">
        <button
          type="button"
          className="inline-flex items-center gap-1.5 text-xs font-medium text-primary hover:underline"
          onClick={onBack}
          disabled={disabled}
        >
          <Icon name="ArrowLeft" size={14} />
          Retour à la notification
        </button>
        {showRemove ? (
          <Button
            type="button"
            variant="outline"
            size="xs"
            iconName="Trash2"
            iconPosition="left"
            onClick={onRemove}
            disabled={disabled}
          >
            Retirer l’événement
          </Button>
        ) : null}
      </div>

      <p className="text-[11px] text-muted-foreground leading-relaxed">
        Événement calendrier lié à l’annonce (heure{' '}
        <span className="font-medium text-foreground">Europe/Paris</span>). Sans
        heure de fin, HubUP applique par défaut{' '}
        <span className="font-medium">+1 h</span> après le début.
      </p>

      <div>
        <label className="text-xs font-medium text-foreground mb-1 block">
          Titre de l’événement <span className="text-error">*</span>
        </label>
        <input
          type="text"
          className={inputClass}
          value={draft.eventTitle}
          disabled={disabled}
          placeholder="Ex. Assemblée générale"
          onChange={(e) => patch({ eventTitle: e.target.value })}
        />
      </div>

      <div>
        <label className="text-xs font-medium text-foreground mb-1 block">
          Description
        </label>
        <textarea
          className={`${inputClass} min-h-[72px] resize-y`}
          value={draft.eventDesc}
          disabled={disabled}
          placeholder="Lieu, consignes, lien visio…"
          onChange={(e) => patch({ eventDesc: e.target.value })}
        />
      </div>

      <div className="grid gap-3 sm:grid-cols-2">
        <div>
          <label className="text-xs font-medium text-foreground mb-1 block">
            Date de début <span className="text-error">*</span>
          </label>
          <input
            type="date"
            className={inputClass}
            value={draft.startDate}
            min={minCalendarDateInputParis()}
            disabled={disabled}
            onChange={(e) => patch({ startDate: e.target.value })}
          />
        </div>
        <div>
          <label className="text-xs font-medium text-foreground mb-1 block">
            Heure de début <span className="text-error">*</span>
          </label>
          <input
            type="time"
            className={inputClass}
            value={draft.startTime}
            disabled={disabled}
            onChange={(e) => patch({ startTime: e.target.value })}
          />
        </div>
      </div>

      <Switch
        checked={!!draft.specifyEnd}
        disabled={disabled}
        label="Définir une heure de fin"
        description="Sinon la fin est calculée automatiquement (+1 h après le début)."
        onChange={(e) => patch({ specifyEnd: e.target.checked })}
      />

      {draft.specifyEnd ? (
        <div className="grid gap-3 sm:grid-cols-2 pl-0 sm:pl-1">
          <div>
            <label className="text-xs font-medium text-foreground mb-1 block">
              Date de fin
            </label>
            <input
              type="date"
              className={inputClass}
              value={draft.endDate}
              min={draft.startDate || minCalendarDateInputParis()}
              disabled={disabled}
              onChange={(e) => patch({ endDate: e.target.value })}
            />
          </div>
          <div>
            <label className="text-xs font-medium text-foreground mb-1 block">
              Heure de fin
            </label>
            <input
              type="time"
              className={inputClass}
              value={draft.endTime}
              disabled={disabled}
              onChange={(e) => patch({ endTime: e.target.value })}
            />
          </div>
        </div>
      ) : null}

    </div>
  );
}
